export interface IAuthProps {
  accessToken: string
  tokenType: string
  expired: number
}

export default class AuthEntity {
  private _props: IAuthProps

  constructor(props?: IAuthProps | null) {
    this._props = EmptyAuthPropsFactory(props)
  }

  get props(): IAuthProps {
    return this._props
  }

  get clone(): IAuthProps {
    return structuredClone(this._props)
  }

  get accessToken(): string {
    return this._props.accessToken
  }

  get tokenType(): string {
    return this._props.tokenType
  }

  get expired(): number {
    return this._props.expired
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyAuthPropsFactory = (props?: Partial<IAuthProps> | null): IAuthProps => ({
  accessToken: '',
  tokenType: '',
  expired: 0,
  ...props
})
